<template>
    <div class="equipe-modal">
        <ui-select-v2
            v-model="newTeam"
            label="Equipe:"
            item-label="label"
            return-value="value"
            :data="dataTeams"
            :loading="loadTeams"
            open-event="change-profile-teams"
            search-event="change-profile-teams"
            ajax-search
            @input="setEquipe"
        />
    </div>
</template>

<script>
import { uiSelectV2       } from '@/components/ui/form'
export default {
    name: 'ui-equipe-manager',
    components: {
        uiSelectV2,
    },
    props: {
        dataTeams: {
            type: Array,
            default: () => []
        },
        loadTeams: {
            type: Boolean,
            default: false
        },
        user:{
            type: [String, Object],
            default: () => {}
        }
    },
    data() {
        return {
            newTeam: this.user.team.id,
            load: false,
            newManager: null,
            managers: null
        }
    },
    
    methods: {
        setEquipe() {
            this.$emit('input', {group: 'manager', team: this.newTeam})
        }
    }
}

</script>

<style lang='stylus' scoped>
    @import '../styles.styl'           
</style>